import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import * as JStorage from '../../JStorage';
import qs from 'query-string';
import Theme from '../../Theme';
import Breadcrumb from '../../Components/Breadcrumb';

function MemberScore(props) {
  return (
    <Wrapper>
      <div className="tda-header">
        <h2>繼續教育積分查詢</h2>
        <Breadcrumb />
      </div>

      <div style={{marginBottom: 20}}>繼續教育查詢學分方法有以下兩種：</div>

      <a
        href="https://cec.mohw.gov.tw/loginpage.aspx"
        className="row"
        target="_blank"
        rel="noreferrer">
        <div className="index">1.</div>
        <div>衛生福利部繼續教育積分管理系統</div>
      </a>

      <a
        href="https://ma.mohw.gov.tw/maportal/default.aspx"
        className="row"
        target="_blank"
        rel="noreferrer">
        <div className="index">2.</div>
        <div>醫事系統入口網</div>
      </a>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .index {
    color: #fff;
    background-color: var(--primaryColor);
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
  }
`;

export default withPageEntry(MemberScore);
